import { getErrorMessage } from '../../utils/errorMessage';
import paymentApi from '../../utils/paymentApi';

function unwrap(response, fallback) {
  const payload = response?.data;
  if (Number(payload?.code) !== 200) {
    const error = new Error(payload?.message || fallback);
    error.code = payload?.data?.error_code || payload?.code;
    throw error;
  }
  return payload?.data || {};
}

export async function getRecentSupportTickets(scene) {
  return unwrap(await paymentApi.get('/support-ticket/list', {
    params: { scene, page: 1, per_page: 5 },
  }), '反馈记录加载失败');
}

export async function createSupportTicket(payload) {
  return unwrap(await paymentApi.post('/support-ticket/create', payload), '反馈提交失败');
}

export async function uploadSupportTicketAttachment(file, { onProgress, signal } = {}) {
  const data = new FormData();
  data.append('file', file);
  return unwrap(await paymentApi.post('/support-ticket/upload-attachment', data, {
    timeout: 120000,
    signal,
    onUploadProgress: event => onProgress?.(event.total ? Math.min(99, Math.round(event.loaded / event.total * 100)) : 0),
  }), '附件上传失败');
}

export async function getSupportTicketAttachment(messageId, attachmentId) {
  return unwrap(await paymentApi.get('/support-ticket/attachment', {
    params: { message_id: messageId, attachment_id: attachmentId },
  }), '附件地址获取失败');
}

export async function confirmSupportTicketResolution(payload) {
  return unwrap(
    await paymentApi.post('/support-ticket/confirm-resolution', payload),
    '反馈确认失败',
  );
}

export function supportTicketRetryAfter(error) {
  const raw = error?.response?.headers?.['retry-after'];
  const seconds = Number.parseInt(String(raw ?? ''), 10);
  return Number.isFinite(seconds) && seconds > 0 ? Math.min(seconds, 3600) : 0;
}

export function supportTicketApiError(error, fallback = '反馈服务暂不可用，请稍后重试') {
  if (Number(error?.response?.status) === 429) {
    const retryAfter = supportTicketRetryAfter(error);
    return getErrorMessage(retryAfter > 0
      ? `操作过于频繁，请等待 ${retryAfter} 秒后直接重试，无需刷新页面。`
      : '操作过于频繁，请稍后直接重试，无需刷新页面。', '操作过于频繁，请稍后直接重试，无需刷新页面。');
  }
  return getErrorMessage(error, fallback);
}
